import Com from "components/styledComp/CommStyledComp";
import React, { useState } from "react";

const yearTabs = ["2021~현재"];

const timelineData = {
  '2021~현재' : [
  {
    year: 2026,
    items: [
      { month: "07", text: "전처리 및 도장 로봇 실시간 수집 기술 개발 용역<br/>(중소조선연구원)" },
      { month: "07", text: "에스마리나㈜와 마리나 운영 시스템 구축 및 운영 MOU 체결" },
      { month: "06", text: "센스 신뢰도 기반 스마트제조 이상 탐지시스템 및 방법 특허출원<br/> (출원번호 : 10-2026-0119849, 2026.06.30)" },
      { month: "03", text: "스마트 제조 시스템 관련 센서 데이터의 이상 탐지를 위한 AI 기술 개발 (부경대 산학 협력)" },
      { month: "03", text: "㈜브라보아이씨티와 출입문 관리 시스템 구축 및 운영 MOU 체결" },
      { month: "01", text: "삼성SDI㈜ MES 2.0 시스템 글로벌 운영 ITO 서비스 운영 계약" },
      { month: "01", text: "한샘㈜ 경영관리 부문 시스템 유지보수 업무 계약" },
    ]
  },
  {
    year: 2025,
    items: [
      { month: "08", text: "FJSSP를 활용한 CNC 기계 생산 스케줄링 개발<br/>(부경대 산학 협력)" },
      { month: "07", text: "한샘㈜ 경영관리 부문 약 50여개의 시스템 유지보수 업무 계약" },
      { month: "04", text: "소비자와 생산자 간 매칭 서버 및 이를 이용한 매칭 방법 특허 등록<br/> (출원번호: 10-2025-0048151 (2025.04.14))" },
      { month: "01", text: "삼성 SDI㈜ MES 2.0 시스템 글로벌 운영 ITO 서비스 운영 계약" },
    ]
  },
  {
    year: 2024,
    items: [
      { month: "07", text: "한샘㈜ 경영관리 부문 약 50여개의 시스템 유지보수 업무 계약" },
      { month: "07", text: "에너에버배터리솔루션㈜ 2차 전지 분리막 코팅 및 슬리팅 공정 MES 시스템 구축 계약( with 코티스㈜ )" },
      { month: "04", text: "에너에버배터리솔루션㈜ 2차전지 분리막 원단 제조공정 프로세스 정립 및 MES 시스템 구축 계약" },
      { month: "01", text: "삼성 SDI㈜ MES 2.0 시스템 글로벌 운영 ITO 서비스 운영 계약" },
      { month: "01", text: "벤처기업등록" },
    ]
  },
  {
    year: 2023,
    items: [
      { month: "10", text: "연구개발 전담부서 설립" },
      { month: "10", text: "서용(주) 제조 경쟁력 강화를 위한 \"스마트제조 실행시스템\" 구축 계약" },
      { month: "07", text: "한샘㈜ 경영관리 부문 약 50여개의 시스템 유지보수 업무 계약" },
      { month: "05", text: "삼성 SDI㈜와 MES 2.0 시스템 구축 글로벌 통합 개발 및 운영 업무 계약" },
    ]
  },
  {
    year: 2022,
    items: [
      { month: "10", text: "삼양식품㈜ 판매계획 기반 생산 계획 및 자재 수급 계획 시스템 구축을 위한 PI 및 설계 컨설팅 수행" },
      { month: "09", text: "세메스㈜ SCM 공급 부문 Planning 제약사항을 반영한 시뮬레이션 기능 설계 컨설팅 수행" },
      { month: "07", text: "한샘㈜ 경영관리 부문 약 50여개의 시스템 유지보수 업무 계약" },
      { month: "05", text: "인텍플렉스㈜ 정보시스템 운영 전략 수립 및 CRM 구축 방안 수립 컨설팅 수행( with 디지이노㈜ )" },
    ]
  },
  {
    year: 2021,
    items: [
      { month: "07", text: "한샘㈜ 경영관리 부문 약 50여개의 시스템 유지보수 업무 계약" },
      { month: "04", text: "한영디에스㈜ 회사 설립" },
    ]
  }]
};

const History2 = () => {
    const [activeTab, setActiveTab] = useState('2021~현재');

    const displayedData = timelineData[activeTab];

  return (
    <div className="company-box majorbusiness">
      <div className="company-box-title">한영<br/>회사연혁</div>
      <div className="company-box-content">
        <Com.Container>
          <Com.TabWrapper>
            {yearTabs.map((tab) => (
              <Com.TabButton
                key={tab}
                active={activeTab === tab}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </Com.TabButton>
            ))}
          </Com.TabWrapper>

          <Com.TimelineGrid>
            {displayedData.map((section) => (
              <Com.YearGroup key={section.year}>
                <Com.YearCell>{section.year}</Com.YearCell>
    
                <Com.LineCell>
                  <Com.Dot />
                </Com.LineCell>
    
                <Com.ItemsCell>
                  {section.items.map((item, i) => (
                    <Com.TimelineItem key={i}>
                      <Com.Month>{item.month}</Com.Month>
                      <span dangerouslySetInnerHTML={{ __html: item.text }} />
                    </Com.TimelineItem>
                  ))}
                </Com.ItemsCell>
              </Com.YearGroup>
            ))}
          </Com.TimelineGrid>
        </Com.Container>
      </div>
    </div>
  );
};

export default History2; 
